import { AppState } from "../../../redux-configuration/AppState";
import { Follower } from "../../domain/entity/follower";

export const loadFollowersLoadingSelector = (appState: AppState): boolean => appState.company.loadFollowers.loading
export const loadFollowersErrorSelector = (appState: AppState): string | undefined => appState.company.loadFollowers.error
export const followersSelector = (appState: AppState): Follower[] | null => appState.company.loadFollowers.followers
